import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeroComponent } from './hero.component';
import { WmCardModule } from '../card/index';
import { WmCaptionModule } from '../caption/index';
import { WmBreadcrumbsModule } from '../breadcrumbs/index';
import { WmButtonModule } from '../button/index';

@NgModule({
	declarations: [HeroComponent],
	imports: [CommonModule, WmCardModule, WmCaptionModule, WmBreadcrumbsModule, WmButtonModule],
	exports: [HeroComponent]
})
export class WmHeroModule {}
